<template functional>
  <div>
    <h5 class="supplier-title">Supplier details:</h5>
    <div class="supplier-container">
      <div v-for="(value, key, index) in props.supplier" :key="index">
        <span class="font-weight-bold">{{ key | capitalize }}:</span>
        <span class="supplier-info"> {{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '@/mixins/filters';

export default {
  name: 'SupplierDetails',
  mixins: [filters],
  props: {
    supplier: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.supplier {
  &-title {
    font-size: 1.5em;
  }

  &-container {
    margin: 1em 0;
    padding-left: 1em;
  }

  &-info {
    padding-left: 0.2em;
  }
}
</style>
